import { REFUND_REASON } from 'domains/customer-order/constants'
import * as Yup from 'yup'


/**
 * Customer Order Refund form schema
 * @param {object} selectedOrderItem - Selected Customer Order Item
 */
const customerOrderRefundSchema = (selectedOrderItem) => Yup.object().shape({
  reason: Yup.string().oneOf(Object.values(REFUND_REASON), 'invalid reason')
    .required('reason required'),
  reason_details: Yup.string().when('reason', {
    is   : (value) => value === 'others',
    then : Yup.string().required(
      'reason details required'
    ),
    otherwise: Yup.string()
  }),
  quantity: Yup.number()
    .positive('Should be positive number')
    .max(selectedOrderItem.quantity, 'Cannot be more than item quantity')
    .required('Required'),
  initiated_by: Yup.string().required('Required')
})

export default customerOrderRefundSchema
